<div class="banner" id="home">
  <app-background class="banner-bg"></app-background>
  <div class="container">
    <div class="bannerSec row">
      <!-- ======= Banner Left Content ======= -->

      <div class="col-12 col-lg-7 leftSec">
        <div class="banner-content">
          <p class="font-13 font-sm-16 text-center text-sm-start heading-title text-uppercase">{{ 'banner.heading_title'
            |
            translate }}</p>
          <h1 class="banner-title mt-4 mb-3 fw-bold">QELT<br /><span class="fw-semibold">{{ 'banner.banner_text_1' |
              translate }}</span>
          </h1>
          <h5 class="font-16 font-sm-20 banner-desc mt-2 mt-sm-3 fw-normal"
            [innerHTML]="'banner.banner_desc' | translate"></h5>

          <div
            class="d-none d-lg-flex flex-column flex-md-row justify-content-center justify-content-md-start mb-3 pt-4 gap-3">
            <div class="btn text-white">
              <img src="/assets/images/svg-icons/fiat-free.svg" alt="Fiat-Free" loading="eager" />
              <span class="ps-2 fw-normal">{{ 'banner.reserve_backend' | translate }}</span>
            </div>
            <div class="btn text-white">
              <img src="/assets/images/svg-icons/reserve-backend.svg" alt="Fiat-Free" loading="eager" />
              <span class="ps-2 fw-normal">{{ 'banner.sovereign_safe' | translate }}</span>
            </div>
            <div class="btn text-white">
              <img src="/assets/images/svg-icons/sovereign-safe.svg" alt="Fiat-Free" loading="eager" />
              <span class="ps-2 fw-normal">{{ 'banner.fast_settlement' | translate }}</span>
            </div>
          </div>

          <div class="limited-offer-box d-none d-lg-block ">
            <!-- <button class="btn btn-primary small vertical-gradient px-4 badge-btn">{{ 'banner.limited_offer' | translate }}</button>
            <div>
              <p class="text-light font-14 mb-0">{{ 'banner.presale' | translate }}</p>
              <p class="text-white font-48 mb-0 fw-bold">+25%</p>
              <p class="text-light font-12 mb-0">{{ 'banner.never_repeated' | translate }}</p>
            </div> -->
            <div class="text-center font-14 text-white mb-3 text-uppercase">{{ 'banner.quick_actions' | translate }}
            </div>
            <div class="d-flex align-items-center justify-content-center gap-3">
              <button class="btn gap-2" (click)="connectModal('Widget-Crypto')">
                {{ 'banner.buy_qxmp' | translate }}
                <svg-icon src="/assets/images/svg-icons/right-icn-arr.svg"></svg-icon>
              </button>
              <a href="/assets/documents/whitepaper.pdf" target="_blank" class="btn whitepaper-btn bg-none gap-2">
                {{ 'misc.whitepaper' | translate }}
              </a>
            </div>
          </div>

        </div>
      </div>
      <!-- ======= Widget goes here ======= -->
      <div class="col-12 col-lg-5">
        <app-widget></app-widget>
        <div class="leftSec">
          <div class="banner-content">
            <div
              class="d-flex d-lg-none flex-column flex-md-row justify-content-center justify-content-md-start mb-3 pt-4 gap-3">
              <div class="btn text-white">
                <img src="/assets/images/svg-icons/fiat-free.svg" alt="Fiat-Free" loading="eager" />
                <span class="ps-2">{{ 'banner.reserve_backend' | translate }}</span>
              </div>
              <div class="btn text-white">
                <img src="/assets/images/svg-icons/reserve-backend.svg" alt="Fiat-Free" loading="eager" />
                <span class="ps-2">{{ 'banner.sovereign_safe' | translate }}</span>
              </div>
              <div class="btn text-white">
                <img src="/assets/images/svg-icons/sovereign-safe.svg" alt="Fiat-Free" loading="eager" />
                <span class="ps-2">{{ 'banner.fast_settlement' | translate }}</span>
              </div>
            </div>

            <div class="limited-offer-box d-block d-lg-none">
              <!-- <button class="btn btn-primary small vertical-gradient px-4 badge-btn">{{ 'banner.limited_offer' | translate }}</button>
              <div>
                <p class="text-light font-14 mb-0">{{ 'banner.presale' | translate }}</p>
                <p class="text-white font-48 mb-0 fw-bold">+25%</p>
                <p class="text-light font-12 mb-0 text-light">{{ 'banner.never_repeated' | translate }}</p>
              </div> -->
              <div class="text-center font-14 text-white mb-3 text-uppercase">{{ 'banner.quick_actions' | translate }}
              </div>
              <div class="d-flex align-items-center justify-content-center gap-3">
                <button class="btn gap-2" (click)="connectModal('Widget-Crypto')">
                  {{ 'banner.buy_qxmp' | translate }}
                  <svg-icon src="/assets/images/svg-icons/right-icn-arr.svg"></svg-icon>
                </button>
                <a href="/assets/documents/whitepaper.pdf" target="_blank"
                  class="btn btn-primary vertical-gradient gap-1 whitepaper-btn">
                  {{ 'misc.whitepaper' | translate }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ======= Widget goes here ======= -->
    </div>
  </div>
</div>
